<template>
	<!-- SideMenu(rightside) -->
	<aside class="iv2-extra-nav theme-c__extra-bg position-fixed text-center d-xl-block">
		<nav class="iv2-extra-nav__sub-menu">
			<ul class="iv2-extra-nav__sub-list list-unstyled">
				<li v-for="nav in extra_menu" :key="nav.id" class="iv2-extra-nav__sub-item theme-c__extra-text">
					<router-link
						v-if="nav.link_type == 'internal'"
						:to="nav.url"
						@click.native="activeMenu = false"
						class="iv2-extra-nav__sub-link theme-c__extra-link"
					>
						<i :class="'iv2-extra-nav__sub-item-icon d-block ' + nav.icon"></i>
						<span class="iv2-extra-nav__sub-item-text d-block">{{nav.name}}</span>
					</router-link>
					<a
						v-else-if="nav.link_type == 'external'"
						v-bind:href="nav.url"
						:target="nav.target_type"
						rel="noopener"
						class="iv2-extra-nav__sub-link theme-c__extra-link"
					>
						<i :class="'iv2-extra-nav__sub-item-icon d-block ' + nav.icon"></i>
						<span class="iv2-extra-nav__sub-item-text d-block">{{nav.name}}</span>
					</a>
					<div v-else-if="nav.link_type == 'push'" class="iv2-extra-push-button">
						<button
							class="iv2-extra-nav__sub-link theme-c__extra-link"
							style="background-color: transparent; border: none;"
						>
							<i :class="'iv2-extra-nav__sub-item-icon d-block ' + nav.icon"></i>
							<span class="iv2-extra-nav__sub-item-text d-block">{{nav.name}}</span>
						</button>
					</div>
				</li>
			</ul>
		</nav>
	</aside>
</template>

<script>
export default {
	data() {
		return {
			extra_menu: []
		};
	},

	created() {
		this.axios.get("/json/navigations.json").then(response => {
			this.extra_menu = response.data.navs.extra_menu;
		});
	}
};
</script>

<style lang="scss">
.iv2-extra-nav {
	.iv2-extra-nav__sub-menu {
		.iv2-extra-nav__sub-list {
			display: flex;
			margin-bottom: 0;
			height: 100%;
			.iv2-extra-nav__sub-item {
				margin-bottom: 16px;
				width: 64px;
				padding: 12px 0;
				margin: 0 7px;
				position: relative;

				&::after {
					content: "";
					display: block;
					height: 30px;
					border-right: 1px solid;
					position: absolute;
					right: -8px;
					top: 19px;
				}

				.iv2-extra-nav__sub-link {
					-webkit-transition: 0.3s;
					transition: 0.3s;
					display: block;

					&:hover {
						text-decoration: none;
						opacity: 0.5;
					}
				}

				.iv2-extra-nav__sub-item-icon {
					font-size: 1.2rem;
					margin-bottom: 6px;
				}

				.iv2-extra-nav__sub-item-text {
					font-size: 10px;
					font-weight: 400;
					line-height: 1.3;
					font-family: Arial, Helvetica, sans-serif;
				}
			}
		}
	}
}

/* PC */
@media (min-width: 1200px) {
}

/* TABLET or SP */
@media (max-width: 1199px) {
}

/* TABLET Only */
@media (min-width: 768px) and (max-width: 1199px) {
}

/* SP Only */
@media (max-width: 767px) {
}
</style>